/* Customer photos: lightbox for .wpu-tile, gallery filter + load more. No dependencies, loaded with defer. */
(() => {
  if (window.wpUgc) return;
  window.wpUgc = true;

  let dlg, img, cap, link, tiles = [], index = 0;

  const build = () => {
    dlg = document.createElement('dialog');
    dlg.className = 'wpu-box';
    dlg.innerHTML =
      '<button type="button" class="wpu-box__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="wpu-box__nav wpu-box__nav--prev" aria-label="Previous photo">&lsaquo;</button>' +
      '<figure class="wpu-box__fig"><img alt=""><figcaption><span></span><a class="wpu-box__link" href="#">Shop this design &rarr;</a></figcaption></figure>' +
      '<button type="button" class="wpu-box__nav wpu-box__nav--next" aria-label="Next photo">&rsaquo;</button>';
    document.body.appendChild(dlg);
    img = dlg.querySelector('img');
    cap = dlg.querySelector('figcaption span');
    link = dlg.querySelector('.wpu-box__link');
    dlg.querySelector('.wpu-box__close').addEventListener('click', () => dlg.close());
    dlg.querySelector('.wpu-box__nav--prev').addEventListener('click', () => show(index - 1));
    dlg.querySelector('.wpu-box__nav--next').addEventListener('click', () => show(index + 1));
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
    let x0 = null;
    dlg.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    dlg.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
  };

  const show = (i) => {
    index = (i + tiles.length) % tiles.length;
    const t = tiles[index];
    img.src = t.dataset.ugcFull;
    img.alt = t.dataset.ugcCaption || '';
    cap.textContent = t.dataset.ugcCaption || '';
    link.hidden = !t.dataset.ugcLink;
    if (t.dataset.ugcLink) link.href = t.dataset.ugcLink;
    // warm up the next photo
    const n = tiles[(index + 1) % tiles.length];
    if (n) new Image().src = n.dataset.ugcFull;
  };

  document.addEventListener('click', (e) => {
    const t = e.target.closest('.wpu-tile');
    if (!t) return;
    const scope = t.closest('[data-ugc-scope]') || document;
    tiles = [...scope.querySelectorAll('.wpu-tile')].filter((x) => x.offsetParent !== null && !x.closest('[aria-hidden="true"]'));
    if (!tiles.includes(t)) tiles = [t];
    if (!dlg) build();
    show(tiles.indexOf(t));
    document.documentElement.style.overflow = 'hidden';
    dlg.showModal();
  });

  // Gallery: theme filter + load more (hidden items are display:none, so their lazy images are not fetched)
  const initGallery = (g) => {
    if (g.dataset.ready) return;
    g.dataset.ready = '1';
    const items = [...g.querySelectorAll('.wpu-gallery__item')];
    const more = g.querySelector('[data-ugc-more]');
    const step = Number(g.dataset.step || 24);
    let theme = 'all', limit = step;
    const render = () => {
      const match = items.filter((it) => theme === 'all' || it.dataset.theme === theme);
      items.forEach((it) => { it.hidden = true; });
      match.slice(0, limit).forEach((it) => { it.hidden = false; });
      if (more) more.hidden = match.length <= limit;
    };
    g.querySelectorAll('[data-ugc-filter]').forEach((b) => b.addEventListener('click', () => {
      theme = b.dataset.ugcFilter;
      limit = step;
      g.querySelectorAll('[data-ugc-filter]').forEach((x) => x.setAttribute('aria-pressed', x === b));
      render();
    }));
    if (more) more.addEventListener('click', () => { limit += step; render(); });
    render();
  };
  const init = () => document.querySelectorAll('[data-ugc-gallery]').forEach(initGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
